import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getInvoicecostplusData = createAsyncThunk("api/invoiceCostPlus", async (token, type, date) => {
    console.log("date to be printed here.......",date,token)
    try {
        const response = await nodeinstance.get("/dashboard/invoiceCostPlus", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const InvoicecostplusDataSlice = createSlice({
    name: "insurance",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getInvoicecostplusData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getInvoicecostplusData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getInvoicecostplusData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getInvoicecostplusData };
export default InvoicecostplusDataSlice.reducer;
